import React from 'react'

import {
  Layout,
  Header,
  SectionTitle,
  ItemTitle,
  Intro,
} from '../../../../components'

import { Link } from 'gatsby'

import data from './data.json'
import fixed from '../../../../images/cardstructure-fixed.png'
import masonry from '../../../../images/cardstructure-masonry.png'
import coll from '../../../../images/cardstructure-collections.png'
import loner from '../../../../images/cardstructure-standalone.png'

export default () => {
  return (
    <>
      <Header
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
      />
      <Layout
        category="Overview"
        site={data.site}
        slug={data.slug + '/develop/'}
        state="develop"
        title={data.title}
        complete={true}
      >
        <Intro>
          <p>
            Cards are containers that separate information to either give it
            prominence within a layout or to creat a predictable pattern for the
            information. They are hyper-customizable and should include whatever
            components will best allow the user to achieve their goal.
          </p>
        </Intro>

        <SectionTitle>Structure</SectionTitle>
        <p>
          The structure of cards is flexible to fit many design needs. They may
          be elevated or outlined, i.e. distinguished from the surrounding
          layout with a stroke or shadow. The elements within a card should make
          use of a logical hierarchy so they are easy to scan. Cards may contain
          a number of actions in the form of buttons, links and inputs. If there
          is one obvious action, the entire card can function as a click target.
        </p>

        <hr />
        <SectionTitle>Grouping</SectionTitle>
        <p>
          Depending on their usage and the information they display, a card may
          be used standalone or grouped into a collection.
        </p>
        <ItemTitle>Standalone</ItemTitle>
        <p>
          Cards that are used to provide visual prominence to salient
          information should be used standalone. These cards often have images,
          larger text hierarchy and singular actions to draw the eye. For an
          example, see the{' '}
          <Link
            class="link"
            to={'/' + data.site + '/patterns/attention-card/design'}
          >
            attention card
          </Link>{' '}
          pattern.
        </p>
        <img src={loner} alt="example of a standalone card" width="100%" />
        <ItemTitle>Collections</ItemTitle>
        <p>
          Cards that are used to create visual patterns to display repeatable
          information are often used in a collection. These cards create visual
          rhythm that ensures a predictable experience. For an example, see the{' '}
          <Link
            class="link"
            to={'/' + data.site + '/patterns/object-card/design'}
          >
            object card
          </Link>{' '}
          pattern.
        </p>
        <img src={coll} alt="example of a card collection" width="100%" />
        <hr />

        <SectionTitle className="l-margin-bottom--xlarge">
          Design Environment
        </SectionTitle>
        <ItemTitle>Fixed Grid</ItemTitle>
        <p>
          On a fixed grid, cards align to fixed columns and variable rows. This
          means that all card heights in a row will match that of the card with
          the most information. All card widths in a collection will be uniform.
          This grid type creates visual rhythm and makes the information in
          cards predictable and easy to scan.
        </p>
        <img src={fixed} alt="cards on a fixed grid" width="100%" />
        <ItemTitle>Masonry Grid</ItemTitle>
        <p>
          Cards of different sizes may be placed on an asymmetric grid. This
          grid type is not suitable for text-heavy cards or cards that contain
          multiple interactions.
        </p>
        <img
          src={masonry}
          alt="cards on a masonry grid"
          width="100%"
          class="l-margin-bottom--xxlarge"
        />
        <p>
          Use the grid type that is best suited to your offered interaction. If
          you are presenting small pieces of consistent information, fixed grids
          work best for quick consumption. If the user will need to interact
          with the card for longer periods of time and the amount of content in
          each card can vary as the user manipulates them, a masonry grid will
          keep your design more compact.
        </p>
        {/*<hr />
        <SectionTitle>Microcopy</SectionTitle>
        <p>
          Cards are meant to give users a glimpse of information, so keep copy
          short. Actions should use strong, clear language that lets the user
          know what will happen when they interact with the card. Follow the
          microcopy guidelines for the individual components that you include in
          cards.
        </p> */}
      </Layout>
    </>
  )
}
